import { render, staticRenderFns } from "./QiyeDetails.vue?vue&type=template&id=83c45080&"
import script from "./QiyeDetails.vue?vue&type=script&lang=js&"
export * from "./QiyeDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports